import {
  COMPANY_COUNTRY_VENDOR_NONE,
  CompanyDataVendorEnum,
  WorkspaceSettingsCompanyDataVendorModel,
} from '../../../shared/models';

export const defaultCompanyDataVendor: WorkspaceSettingsCompanyDataVendorModel =
  {
    AF: CompanyDataVendorEnum.creditsafe, // Afghanistan
    AX: COMPANY_COUNTRY_VENDOR_NONE,
    AL: CompanyDataVendorEnum.creditsafe, // Albania
    DZ: COMPANY_COUNTRY_VENDOR_NONE,
    AS: COMPANY_COUNTRY_VENDOR_NONE,
    AD: COMPANY_COUNTRY_VENDOR_NONE,
    AO: CompanyDataVendorEnum.creditsafe, // Angola
    AI: COMPANY_COUNTRY_VENDOR_NONE,
    AQ: COMPANY_COUNTRY_VENDOR_NONE,
    AG: COMPANY_COUNTRY_VENDOR_NONE,
    AR: CompanyDataVendorEnum.creditsafe, // Argentina
    AM: COMPANY_COUNTRY_VENDOR_NONE,
    AW: COMPANY_COUNTRY_VENDOR_NONE,
    AU: CompanyDataVendorEnum.creditsafe, // Australia
    AT: CompanyDataVendorEnum.kompany, // Austria
    AZ: COMPANY_COUNTRY_VENDOR_NONE,
    BS: COMPANY_COUNTRY_VENDOR_NONE,
    BH: CompanyDataVendorEnum.kompany, // Bahrain
    BD: COMPANY_COUNTRY_VENDOR_NONE,
    BB: COMPANY_COUNTRY_VENDOR_NONE,
    BY: COMPANY_COUNTRY_VENDOR_NONE,
    BE: CompanyDataVendorEnum.creditsafe, // Belgium
    BZ: COMPANY_COUNTRY_VENDOR_NONE,
    BJ: COMPANY_COUNTRY_VENDOR_NONE,
    BM: COMPANY_COUNTRY_VENDOR_NONE,
    BT: COMPANY_COUNTRY_VENDOR_NONE,
    BO: COMPANY_COUNTRY_VENDOR_NONE,
    BQ: COMPANY_COUNTRY_VENDOR_NONE,
    BA: CompanyDataVendorEnum.creditsafe, // Bosnia & Herzegovina
    BW: CompanyDataVendorEnum.creditsafe, // Botswana
    BV: COMPANY_COUNTRY_VENDOR_NONE,
    BR: CompanyDataVendorEnum.kompany, // Brazil
    IO: COMPANY_COUNTRY_VENDOR_NONE,
    VG: COMPANY_COUNTRY_VENDOR_NONE,
    BN: COMPANY_COUNTRY_VENDOR_NONE,
    BG: CompanyDataVendorEnum.creditsafe, // Bulgaria
    BF: COMPANY_COUNTRY_VENDOR_NONE,
    BI: CompanyDataVendorEnum.creditsafe, // Burundi
    CV: CompanyDataVendorEnum.creditsafe, // Cape Verde
    KH: CompanyDataVendorEnum.creditsafe, // Cambodia
    CM: CompanyDataVendorEnum.creditsafe, // Cameroon
    CA: CompanyDataVendorEnum.kompany, // Canada
    KY: COMPANY_COUNTRY_VENDOR_NONE,
    CF: CompanyDataVendorEnum.creditsafe, // Central African Republic
    TD: CompanyDataVendorEnum.creditsafe, // Chad
    CL: CompanyDataVendorEnum.creditsafe, // Chile
    CN: CompanyDataVendorEnum.kyckr, // China
    CX: COMPANY_COUNTRY_VENDOR_NONE,
    CC: COMPANY_COUNTRY_VENDOR_NONE,
    CO: COMPANY_COUNTRY_VENDOR_NONE,
    KM: COMPANY_COUNTRY_VENDOR_NONE,
    CG: CompanyDataVendorEnum.creditsafe, // Congo
    CK: COMPANY_COUNTRY_VENDOR_NONE,
    CR: COMPANY_COUNTRY_VENDOR_NONE,
    CI: CompanyDataVendorEnum.creditsafe, // Ivory Coast
    HR: CompanyDataVendorEnum.creditsafe, // Croatia
    CU: COMPANY_COUNTRY_VENDOR_NONE,
    CW: COMPANY_COUNTRY_VENDOR_NONE,
    CY: CompanyDataVendorEnum.creditsafe, // Cyprus
    CZ: CompanyDataVendorEnum.creditsafe, // Czech Republic
    CD: COMPANY_COUNTRY_VENDOR_NONE,
    DK: CompanyDataVendorEnum.kyckr, // Denmark
    DJ: CompanyDataVendorEnum.creditsafe, // Djibouti
    DM: COMPANY_COUNTRY_VENDOR_NONE,
    DO: COMPANY_COUNTRY_VENDOR_NONE,
    EC: COMPANY_COUNTRY_VENDOR_NONE,
    EG: COMPANY_COUNTRY_VENDOR_NONE,
    SV: COMPANY_COUNTRY_VENDOR_NONE,
    GQ: CompanyDataVendorEnum.creditsafe, // Equatorial Guinea
    ER: CompanyDataVendorEnum.creditsafe, // Eritrea
    EE: CompanyDataVendorEnum.kyckr, // Estonia
    ET: CompanyDataVendorEnum.creditsafe, // Ethiopia
    FK: COMPANY_COUNTRY_VENDOR_NONE,
    FO: COMPANY_COUNTRY_VENDOR_NONE,
    FJ: COMPANY_COUNTRY_VENDOR_NONE,
    FI: CompanyDataVendorEnum.creditsafe, // Finland
    FR: CompanyDataVendorEnum.pappers, // France
    GF: COMPANY_COUNTRY_VENDOR_NONE,
    PF: CompanyDataVendorEnum.pappers, // French Polynesia
    TF: CompanyDataVendorEnum.pappers, // French southern and Antarctic lands
    GA: CompanyDataVendorEnum.creditsafe, // Gabon
    GM: CompanyDataVendorEnum.creditsafe, // Gambia
    GE: CompanyDataVendorEnum.kompany, // Georgia
    DE: CompanyDataVendorEnum.creditsafe, // Germany
    GH: CompanyDataVendorEnum.creditsafe, // Ghana
    GI: CompanyDataVendorEnum.kompany, // Gibraltar
    GR: CompanyDataVendorEnum.kompany, // Greece
    GL: CompanyDataVendorEnum.kompany, // Greenland
    GD: COMPANY_COUNTRY_VENDOR_NONE,
    GP: CompanyDataVendorEnum.pappers, // Guadeloupe
    GU: COMPANY_COUNTRY_VENDOR_NONE,
    GT: COMPANY_COUNTRY_VENDOR_NONE,
    GG: CompanyDataVendorEnum.kyckr, // Guernsey
    GN: CompanyDataVendorEnum.creditsafe, // Guinea
    GW: CompanyDataVendorEnum.creditsafe, // Guinea-Bissau
    GY: CompanyDataVendorEnum.pappers, // Guyana
    HT: COMPANY_COUNTRY_VENDOR_NONE,
    HM: COMPANY_COUNTRY_VENDOR_NONE,
    VA: COMPANY_COUNTRY_VENDOR_NONE,
    HN: COMPANY_COUNTRY_VENDOR_NONE,
    HK: CompanyDataVendorEnum.kompany, // Hong Kong
    HU: CompanyDataVendorEnum.creditsafe, // Hungary
    IS: CompanyDataVendorEnum.creditsafe, // Iceland
    IN: CompanyDataVendorEnum.kyckr, // India
    ID: COMPANY_COUNTRY_VENDOR_NONE,
    IR: COMPANY_COUNTRY_VENDOR_NONE,
    IQ: COMPANY_COUNTRY_VENDOR_NONE,
    IE: CompanyDataVendorEnum.creditsafe, // Ireland
    IM: COMPANY_COUNTRY_VENDOR_NONE,
    IL: CompanyDataVendorEnum.kompany, // Israel
    IT: CompanyDataVendorEnum.kompany, // Italy
    JM: COMPANY_COUNTRY_VENDOR_NONE,
    JP: CompanyDataVendorEnum.creditsafe, // Japan
    JE: CompanyDataVendorEnum.kyckr, // Jersey
    JO: CompanyDataVendorEnum.kompany, // Jordan
    KZ: COMPANY_COUNTRY_VENDOR_NONE,
    KE: CompanyDataVendorEnum.creditsafe, // Kenya
    KI: COMPANY_COUNTRY_VENDOR_NONE,
    XK: CompanyDataVendorEnum.creditsafe, // Kosovo
    KW: COMPANY_COUNTRY_VENDOR_NONE,
    KG: COMPANY_COUNTRY_VENDOR_NONE,
    LA: CompanyDataVendorEnum.creditsafe, // Laos
    LV: CompanyDataVendorEnum.kompany, // Latvia
    LB: COMPANY_COUNTRY_VENDOR_NONE,
    LS: CompanyDataVendorEnum.creditsafe, // Lesotho
    LR: CompanyDataVendorEnum.creditsafe, // Liberia
    LY: COMPANY_COUNTRY_VENDOR_NONE,
    LI: CompanyDataVendorEnum.creditsafe, // Liechtenstein
    LT: CompanyDataVendorEnum.kyckr, // Lithuania
    LU: CompanyDataVendorEnum.creditsafe, // Luxembourg
    MO: COMPANY_COUNTRY_VENDOR_NONE,
    MG: CompanyDataVendorEnum.creditsafe, // Madagascar
    MW: CompanyDataVendorEnum.creditsafe, // Malawi
    MY: CompanyDataVendorEnum.kompany, // Malaysia
    MV: COMPANY_COUNTRY_VENDOR_NONE,
    ML: CompanyDataVendorEnum.creditsafe, // Mali
    MT: CompanyDataVendorEnum.creditsafe, // Malta
    MH: COMPANY_COUNTRY_VENDOR_NONE,
    MQ: CompanyDataVendorEnum.pappers, // Martinique
    MR: CompanyDataVendorEnum.creditsafe, // Mauritania
    MU: CompanyDataVendorEnum.creditsafe, // Mauritius
    YT: CompanyDataVendorEnum.pappers, // Mayotte
    MX: CompanyDataVendorEnum.creditsafe, // Mexico
    FM: COMPANY_COUNTRY_VENDOR_NONE,
    MD: CompanyDataVendorEnum.creditsafe, // Moldova
    MC: COMPANY_COUNTRY_VENDOR_NONE,
    MN: COMPANY_COUNTRY_VENDOR_NONE,
    ME: CompanyDataVendorEnum.creditsafe, // Montenegro
    MS: COMPANY_COUNTRY_VENDOR_NONE,
    MA: COMPANY_COUNTRY_VENDOR_NONE,
    MZ: CompanyDataVendorEnum.creditsafe, // Mozambique
    MM: CompanyDataVendorEnum.creditsafe, // Myanmar
    NA: CompanyDataVendorEnum.creditsafe, // Namibia
    NR: COMPANY_COUNTRY_VENDOR_NONE,
    NP: COMPANY_COUNTRY_VENDOR_NONE,
    NL: CompanyDataVendorEnum.kyckr, // Netherlands
    NC: CompanyDataVendorEnum.pappers, // New Caledonia
    NZ: CompanyDataVendorEnum.kompany, // New Zealand
    NI: COMPANY_COUNTRY_VENDOR_NONE,
    NE: CompanyDataVendorEnum.creditsafe, // Niger
    NG: CompanyDataVendorEnum.creditsafe, // Nigeria
    NU: COMPANY_COUNTRY_VENDOR_NONE,
    NF: COMPANY_COUNTRY_VENDOR_NONE,
    KP: COMPANY_COUNTRY_VENDOR_NONE,
    MK: CompanyDataVendorEnum.creditsafe, // Macedonia
    MP: COMPANY_COUNTRY_VENDOR_NONE,
    NO: CompanyDataVendorEnum.creditsafe, // Norway
    OM: COMPANY_COUNTRY_VENDOR_NONE,
    PK: COMPANY_COUNTRY_VENDOR_NONE,
    PW: COMPANY_COUNTRY_VENDOR_NONE,
    PS: COMPANY_COUNTRY_VENDOR_NONE,
    PA: COMPANY_COUNTRY_VENDOR_NONE,
    PG: COMPANY_COUNTRY_VENDOR_NONE,
    PY: COMPANY_COUNTRY_VENDOR_NONE,
    PE: COMPANY_COUNTRY_VENDOR_NONE,
    PH: COMPANY_COUNTRY_VENDOR_NONE,
    PN: COMPANY_COUNTRY_VENDOR_NONE,
    PL: CompanyDataVendorEnum.creditsafe, // Poland
    PT: CompanyDataVendorEnum.creditsafe, // Portugal
    PR: COMPANY_COUNTRY_VENDOR_NONE,
    QA: COMPANY_COUNTRY_VENDOR_NONE,
    RE: CompanyDataVendorEnum.pappers, // Reunion
    RO: CompanyDataVendorEnum.creditsafe, // Romania
    RU: CompanyDataVendorEnum.kompany, // Russia
    RW: CompanyDataVendorEnum.creditsafe, // Rwanda
    BL: CompanyDataVendorEnum.pappers, // Saint barthélemy
    SH: CompanyDataVendorEnum.creditsafe, // Saint Helena
    KN: COMPANY_COUNTRY_VENDOR_NONE,
    LC: COMPANY_COUNTRY_VENDOR_NONE,
    MF: CompanyDataVendorEnum.pappers, // Saint martin
    PM: CompanyDataVendorEnum.pappers, // Saint Pierre et Miquelon
    VC: COMPANY_COUNTRY_VENDOR_NONE,
    WS: COMPANY_COUNTRY_VENDOR_NONE,
    SM: COMPANY_COUNTRY_VENDOR_NONE,
    ST: CompanyDataVendorEnum.creditsafe, // Sao Tome and Principe
    SA: COMPANY_COUNTRY_VENDOR_NONE,
    SN: CompanyDataVendorEnum.creditsafe, // Senegal
    RS: CompanyDataVendorEnum.creditsafe, // Serbia
    SC: CompanyDataVendorEnum.creditsafe, // Seychelles
    SL: CompanyDataVendorEnum.creditsafe, // Sierra Leone
    SG: CompanyDataVendorEnum.kyckr, // Singapore
    SX: COMPANY_COUNTRY_VENDOR_NONE,
    SK: CompanyDataVendorEnum.creditsafe, // Slovakia
    SI: CompanyDataVendorEnum.creditsafe, // Slovenia
    SB: COMPANY_COUNTRY_VENDOR_NONE,
    SO: CompanyDataVendorEnum.creditsafe, // Somalia
    ZA: CompanyDataVendorEnum.creditsafe, // South Africa
    GS: COMPANY_COUNTRY_VENDOR_NONE,
    KR: CompanyDataVendorEnum.creditsafe, // South Korea
    SS: COMPANY_COUNTRY_VENDOR_NONE,
    ES: CompanyDataVendorEnum.creditsafe, // Spain
    LK: COMPANY_COUNTRY_VENDOR_NONE,
    SD: COMPANY_COUNTRY_VENDOR_NONE,
    SR: COMPANY_COUNTRY_VENDOR_NONE,
    SJ: COMPANY_COUNTRY_VENDOR_NONE,
    SZ: CompanyDataVendorEnum.creditsafe, // Eswatini
    SE: CompanyDataVendorEnum.creditsafe, // Sweden
    CH: CompanyDataVendorEnum.kompany, // Switzerland
    SY: COMPANY_COUNTRY_VENDOR_NONE,
    TW: CompanyDataVendorEnum.creditsafe, // Taiwan
    TJ: COMPANY_COUNTRY_VENDOR_NONE,
    TZ: CompanyDataVendorEnum.creditsafe, // Tanzania
    TH: CompanyDataVendorEnum.creditsafe, // Thailand
    TL: COMPANY_COUNTRY_VENDOR_NONE,
    TG: CompanyDataVendorEnum.creditsafe, // Togo
    TK: COMPANY_COUNTRY_VENDOR_NONE,
    TO: COMPANY_COUNTRY_VENDOR_NONE,
    TT: COMPANY_COUNTRY_VENDOR_NONE,
    TN: COMPANY_COUNTRY_VENDOR_NONE,
    TR: COMPANY_COUNTRY_VENDOR_NONE,
    TM: COMPANY_COUNTRY_VENDOR_NONE,
    TC: COMPANY_COUNTRY_VENDOR_NONE,
    TV: COMPANY_COUNTRY_VENDOR_NONE,
    UG: CompanyDataVendorEnum.creditsafe, // Uganda
    UA: CompanyDataVendorEnum.creditsafe, // Ukraine
    AE: CompanyDataVendorEnum.kyckr, // United Arab Emirates
    GB: CompanyDataVendorEnum.companies_house, // United Kingdom
    US: CompanyDataVendorEnum.kompany, // United States
    UM: COMPANY_COUNTRY_VENDOR_NONE,
    UY: COMPANY_COUNTRY_VENDOR_NONE,
    VI: COMPANY_COUNTRY_VENDOR_NONE,
    UZ: COMPANY_COUNTRY_VENDOR_NONE,
    VU: COMPANY_COUNTRY_VENDOR_NONE,
    VE: COMPANY_COUNTRY_VENDOR_NONE,
    VN: CompanyDataVendorEnum.creditsafe, // Vietnam
    WF: CompanyDataVendorEnum.pappers, // Wallis and Futuna
    EH: COMPANY_COUNTRY_VENDOR_NONE,
    YE: COMPANY_COUNTRY_VENDOR_NONE,
    ZM: CompanyDataVendorEnum.creditsafe, // Zambia
    ZW: CompanyDataVendorEnum.creditsafe, // Zimbabwe
  };
